import React from 'react'
import { useTranslation } from 'react-i18next'
import './TableEmptyState.css'

type TableEmptyStateProps = {
  title?: string
  hint?: string
  /** Smaller padding for DataGrid overlays */
  compact?: boolean
}

/** Polished empty state for list tables and DataGrid overlays. */
export default function TableEmptyState({
  title,
  hint,
  compact = false,
}: TableEmptyStateProps) {
  const { t } = useTranslation()
  return (
    <div
      className={`incyia-empty${compact ? ' is-compact' : ''}`}
      role="status"
    >
      <span className="incyia-empty-icon" aria-hidden>
        <svg viewBox="0 0 24 24" fill="none">
          <rect
            x="3.5"
            y="5"
            width="17"
            height="14"
            rx="3"
            stroke="currentColor"
            strokeWidth="1.5"
          />
          <path
            d="M3.5 9.5h17"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path
            d="M8 13.5h4.5M8 16.5h8"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </svg>
      </span>
      <p className="incyia-empty-title">
        {title ??
          t('listPages.emptyTitle', {
            defaultValue: 'Nothing to show yet',
          })}
      </p>
      <p className="incyia-empty-hint">
        {hint ??
          t('listPages.emptyHint', {
            defaultValue:
              'Try adjusting filters, or check back once records are added.',
          })}
      </p>
    </div>
  )
}
